import React from 'react'
import flightIcon from '../../../../../../assets/03.png'
import ReportFilterModal from './ReportFilterModal';

const EmptyReport : React.FC = () => {

  const [openModal, setOpenModal] = React.useState<boolean>(false);

  return (
    <div className='flex flex-col justify-between'>
        <ReportFilterModal
           openModal={openModal} setOpenModal={setOpenModal}
         />
        <img src={flightIcon} alt="flight image" className='w-[800px] h-[300px] mx-auto block' />
        <div className='text-center mt-5'>
            <h3 className='text-md text-center text-primary font-semibold'>
              Unlock Insights With Your Automated Report
            </h3>
            <p className='text-sm mt-1 mb-4 w-[60%] mx-auto text-center'>
              Generate a comprehensive report to analyze your course
               performance, track learner progress, and identify 
               areas for improvement. Tailor your content strategy
                with data-driven insights.
            </p>
            <button 
              className='btn mt-3 w-[300px] text-center bg-primary-blue'
              onClick={() => setOpenModal(true)}
            >
                 Generate Report 
            </button>
        </div>
    </div>
  )
}

export default EmptyReport